var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: ["status-bar", { active: _vm.isActive }] }, [
    _c("div", { staticClass: "active-bar" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }